// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v3vy","importantInfo":"styles_importantInfo__2F2tk"};